"use client";

import { c as _c } from "react/compiler-runtime";
import type { TournamentDetailView } from "@clutch/auth/actions/tournaments";
import { format } from "date-fns";
import { QRCodeSVG } from "qrcode.react";
import Logo from "@/components/brand/Logo";
import { cn } from "@/lib/utils";
type TournamentCardProps = {
  tournament: TournamentDetailView;
  url: string;
  className?: string;
};
function statusAccent(status: string): {
  dot: string;
  text: string;
} {
  if (status === "registration_open") {
    return {
      dot: "bg-emerald-500",
      text: "text-emerald-700"
    };
  }
  if (status === "in_progress" || status === "fixtures_generated") {
    return {
      dot: "bg-blue-500",
      text: "text-blue-700"
    };
  }
  if (status === "completed") {
    return {
      dot: "bg-muted-foreground",
      text: "text-foreground/80"
    };
  }
  return {
    dot: "bg-muted-foreground/60",
    text: "text-muted-foreground"
  };
}
export function TournamentCard(t0) {
  const $ = _c(78);
  const {
    tournament,
    url,
    className
  } = t0;
  const primaryVenue = tournament.venues[0] ?? null;
  let dateRange;
  let deadline;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== className || $[1] !== tournament.availability.isRegistrationOpen || $[2] !== tournament.endDate || $[3] !== tournament.registrationDeadline || $[4] !== tournament.sportName || $[5] !== tournament.startDate || $[6] !== tournament.status) {
    const accent = statusAccent(tournament.availability.isRegistrationOpen ? "registration_open" : tournament.status);
    let t10;
    if ($[18] !== tournament.startDate) {
      t10 = format(new Date(tournament.startDate), "MMM d");
      $[18] = tournament.startDate;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let t11;
    if ($[20] !== tournament.endDate) {
      t11 = format(new Date(tournament.endDate), "MMM d, yyyy");
      $[20] = tournament.endDate;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    dateRange = `${t10} – ${t11}`;
    let t12;
    if ($[22] !== tournament.registrationDeadline) {
      t12 = format(new Date(tournament.registrationDeadline), "MMM d, yyyy \xB7 h:mm a");
      $[22] = tournament.registrationDeadline;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    deadline = t12;
    if ($[24] !== className) {
      t8 = cn("flex w-full flex-col overflow-hidden rounded-3xl border border-border/70 bg-white text-neutral-900", className);
      $[24] = className;
      $[25] = t8;
    } else {
      t8 = $[25];
    }
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="flex items-center justify-between border-neutral-200 border-b bg-neutral-50 px-6 py-4"><Logo variant="combo" size="sm" className="text-neutral-900 opacity-80" /><span className="font-bold text-[10px] text-neutral-400 uppercase tracking-[0.25em]">Tournament</span></div>;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    t7 = "flex flex-1 flex-col gap-6 px-6 py-6";
    t6 = "space-y-3";
    t4 = "flex flex-wrap items-center gap-2";
    if ($[27] !== tournament.sportName) {
      t5 = <span className="inline-flex items-center rounded-full bg-neutral-100 px-3 py-1 font-semibold text-neutral-900 text-xs">{tournament.sportName}</span>;
      $[27] = tournament.sportName;
      $[28] = t5;
    } else {
      t5 = $[28];
    }
    t3 = cn("inline-flex items-center gap-1.5 rounded-full bg-neutral-50 px-3 py-1 font-semibold text-xs", accent.text);
    t1 = true;
    t2 = cn("relative flex h-2 w-2 rounded-full", accent.dot);
    $[0] = className;
    $[1] = tournament.availability.isRegistrationOpen;
    $[2] = tournament.endDate;
    $[3] = tournament.registrationDeadline;
    $[4] = tournament.sportName;
    $[5] = tournament.startDate;
    $[6] = tournament.status;
    $[7] = dateRange;
    $[8] = deadline;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    dateRange = $[7];
    deadline = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t10;
  if ($[29] !== tournament.availability.isRegistrationOpen) {
    t10 = tournament.availability.isRegistrationOpen && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />;
    $[29] = tournament.availability.isRegistrationOpen;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t1 || $[32] !== t10 || $[33] !== t2) {
    t11 = <span aria-hidden={t1} className={t2}>{t10}</span>;
    $[31] = t1;
    $[32] = t10;
    $[33] = t2;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t3 || $[37] !== tournament.availability.label) {
    t12 = <span className={t3}>{t11}{tournament.availability.label}</span>;
    $[35] = t11;
    $[36] = t3;
    $[37] = tournament.availability.label;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t12 || $[40] !== t4 || $[41] !== t5) {
    t13 = <div className={t4}>{t5}{t12}</div>;
    $[39] = t12;
    $[40] = t4;
    $[41] = t5;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== tournament.name) {
    t14 = <h2 className="font-extrabold text-2xl text-neutral-900 leading-tight tracking-tight">{tournament.name}</h2>;
    $[43] = tournament.name;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== t13 || $[46] !== t14 || $[47] !== t6) {
    t15 = <div className={t6}>{t13}{t14}</div>;
    $[45] = t13;
    $[46] = t14;
    $[47] = t6;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  let t16;
  if ($[49] !== dateRange) {
    t16 = <InfoRow label="Dates" value={dateRange} />;
    $[49] = dateRange;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== primaryVenue) {
    t17 = primaryVenue && <InfoRow label="Venue" value={primaryVenue.name} secondary={primaryVenue.address} />;
    $[51] = primaryVenue;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== deadline) {
    t18 = <InfoRow label="Closes" value={deadline} />;
    $[53] = deadline;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  let t19;
  if ($[55] !== t16 || $[56] !== t17 || $[57] !== t18) {
    t19 = <div className="flex flex-1 flex-col justify-center gap-4">{t16}{t17}{t18}</div>;
    $[55] = t16;
    $[56] = t17;
    $[57] = t18;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== url) {
    t20 = <div className="flex size-28 items-center justify-center rounded-xl bg-white p-1.5"><QRCodeSVG value={url} size={96} bgColor="#ffffff" fgColor="#111111" level="M" marginSize={0} /></div>;
    $[59] = url;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  let t21;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="font-bold text-[9px] text-neutral-400 uppercase tracking-[0.2em]">Scan to register</span>;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== t20) {
    t22 = <div className="flex shrink-0 flex-col items-center justify-center gap-2 rounded-2xl border border-neutral-200 bg-neutral-50 p-3 px-4">{t20}{t21}</div>;
    $[62] = t20;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  let t23;
  if ($[64] !== t19 || $[65] !== t22) {
    t23 = <div className="flex gap-5">{t19}{t22}</div>;
    $[64] = t19;
    $[65] = t22;
    $[66] = t23;
  } else {
    t23 = $[66];
  }
  let t24;
  if ($[67] !== t15 || $[68] !== t23 || $[69] !== t7) {
    t24 = <div className={t7}>{t15}{t23}</div>;
    $[67] = t15;
    $[68] = t23;
    $[69] = t7;
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  let t25;
  if ($[71] !== tournament.publicCode) {
    t25 = <div className="flex items-center justify-center border-neutral-200 border-t bg-neutral-50 px-6 py-3"><span className="font-bold text-neutral-900 text-xs uppercase tracking-[0.15em]">{tournament.publicCode}</span></div>;
    $[71] = tournament.publicCode;
    $[72] = t25;
  } else {
    t25 = $[72];
  }
  let t26;
  if ($[73] !== t24 || $[74] !== t25 || $[75] !== t8 || $[76] !== t9) {
    t26 = <div className={t8}>{t9}{t24}{t25}</div>;
    $[73] = t24;
    $[74] = t25;
    $[75] = t8;
    $[76] = t9;
    $[77] = t26;
  } else {
    t26 = $[77];
  }
  return t26;
}
function InfoRow(t0) {
  const $ = _c(10);
  const {
    label,
    value,
    secondary
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="font-bold text-[9px] text-neutral-400 uppercase tracking-[0.2em]">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <span className="font-semibold text-neutral-900 text-sm leading-snug">{value}</span>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== secondary) {
    t3 = secondary && <span className="text-[11px] text-neutral-500 leading-snug">{secondary}</span>;
    $[4] = secondary;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex flex-col gap-0.5">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}